import { render, staticRenderFns } from "./ReferralAccountPage.vue?vue&type=template&id=21b65322&scoped=true"
import script from "./ReferralAccountPage.vue?vue&type=script&lang=js"
export * from "./ReferralAccountPage.vue?vue&type=script&lang=js"
import style0 from "./ReferralAccountPage.vue?vue&type=style&index=0&id=21b65322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b65322",
  null
  
)

export default component.exports